import {useLayoutEffect} from 'react'

import {LogEnv, initCommonLogsEnv} from '@financial/common-logs'

import {isLocalProfile, isDevProfile, isAlphaProfile, isBetaProfile, isRealProfile} from '@web/core/config'

/**
 * PIE 레포 common-logs 사용을 위한
 * 환경변수 세팅
 */
const useCommonLogInit = () => {
    /**
     * 앱 구동 환경별 로그 제출할 destination 주소 및 로거 설정 초기화. 기본은 real 도메인으로 제출된다
     */
    useLayoutEffect(() => {
        ;(isLocalProfile || isDevProfile || isAlphaProfile) && initCommonLogsEnv(LogEnv.dev)
        isBetaProfile && initCommonLogsEnv(LogEnv.stage)
        isRealProfile && initCommonLogsEnv(LogEnv.real)
    }, [])
}

export default useCommonLogInit
